import { mergeUint8, toHex } from '@polkadot-api/utils';
import { Blake2128Concat } from './hashes/blake2.mjs';
import '@noble/hashes/blake3';
import { Identity } from './hashes/identity.mjs';
import { Twox128, Twox64Concat } from './hashes/twoX.mjs';

const textEncoder = new TextEncoder();
const Storage = (pallet) => {
  const palledEncoded = Twox128(textEncoder.encode(pallet));
  return (name, dec, ...encoders) => {
    const palletItemEncoded = mergeUint8(
      palledEncoded,
      Twox128(textEncoder.encode(name))
    );
    const palletItemEncodedHex = toHex(palletItemEncoded);
    const bytesToSkip = encoders.map((e) => e[1]).map((x) => {
      switch (x) {
        case Identity:
          return 0;
        case Twox64Concat:
          return 8;
        case Blake2128Concat:
          return 16;
        default:
          return null;
      }
    }).filter((x) => x !== null);
    const keyDecoder = (key) => {
      if (!key.startsWith(palletItemEncodedHex))
        throw new Error(`key does not match this storage (${pallet}.${name})`);
      if (bytesToSkip.length !== encoders.length)
        throw new Error("Impossible to decode this key");
      if (encoders.length === 0) return [];
      const argsKey = key.slice(palletItemEncodedHex.length);
      const result = new Array(encoders.length);
      for (let i = 0, cur = 0; i < bytesToSkip.length; i++) {
        const codec = encoders[i][0];
        cur += bytesToSkip[i];
        result[i] = codec.dec(argsKey.slice(cur * 2));
        cur += codec.enc(result[i]).length;
      }
      return result;
    };
    const fns = encoders.map(
      ([{ enc: enc2 }, hash]) => (val) => hash(enc2(val))
    );
    const enc = (...args) => toHex(
      mergeUint8(palletItemEncoded, ...args.map((val, idx) => fns[idx](val)))
    );
    return {
      enc,
      dec,
      keyDecoder
    };
  };
};

export { Storage };
//# sourceMappingURL=storage.mjs.map
